import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenusServices } from '@app/services/menus.service';
import { BaseComponent } from '@app/components/base/base.component';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationService } from '@app/services/notifications.service';
import { RolesInternal } from '@app/models/roles.enum';
import { ModalService } from '@app/components/modal/modal.service';
import { AuthService } from '@app/common/auth.service';

@Component({
  selector: 'app-financial-setup',
  templateUrl: './financial-setup.component.html',
  styleUrl: './financial-setup.component.css'
})
export class FinancialSetupComponent {

}
